// extracted by mini-css-extract-plugin
export default {"chipLabel":"ug0L0scoFr9v0OvG8OrG"};